import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function askCouncil(question) {
  const { data } = await axios.post(`${API}/ask`, { question });
  return data;
}

export async function generateWorksheet(sessions, library_questions) {
  const { data } = await axios.post(`${API}/worksheet`, { sessions, library_questions });
  return data;
}

export async function sendChat(payload) {
  const { data } = await axios.post(`${API}/chat`, payload);
  return data;
}

export async function startCheckout(clientId) {
  const { data } = await axios.post(`${API}/payments/checkout`, {
    lookup_key: "synapse_unlock",
    origin_url: window.location.origin,
    client_id: clientId,
  });
  return data;
}

export async function paymentStatus(sessionId) {
  const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
  return data;
}

export { API };
